import React, { useContext, createContext, useReducer } from "react";

export const DataLayerContext = createContext();


export const DataLayer = ({ intialstate, reducer, children }) => (
    <DataLayerContext.Provider value={useReducer(reducer, intialstate)}>
        {children}
    </DataLayerContext.Provider>
);

export const useDataLayerValue = () => useContext(DataLayerContext);



